import { render } from "./FactorDescDialog.vue?vue&type=template&id=428eede5&scoped=true&ts=true"
import script from "./FactorDescDialog.vue?vue&type=script&lang=ts"
export * from "./FactorDescDialog.vue?vue&type=script&lang=ts"

import "./FactorDescDialog.vue?vue&type=style&index=0&id=428eede5&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428eede5"]])

export default __exports__